package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.KeyboardArrowRightW500Rounded: ImageVector
    get() {
        if (_keyboardArrowRightW500Rounded != null) {
            return _keyboardArrowRightW500Rounded!!
        }
        _keyboardArrowRightW500Rounded = Builder(name = "KeyboardArrowRightW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(496.35f, 480.0f)
                lineTo(344.17f, 327.83f)
                quadTo(331.5f, 315.15f, 331.5f, 296.0f)
                reflectiveQuadToRelative(12.67f, -31.83f)
                quadTo(356.85f, 251.5f, 376.0f, 251.5f)
                reflectiveQuadToRelative(31.83f, 12.67f)
                lineToRelative(183.76f, 183.76f)
                quadToRelative(6.71f, 6.72f, 9.81f, 14.92f)
                quadToRelative(3.1f, 8.19f, 3.1f, 17.15f)
                quadToRelative(0.0f, 8.96f, -3.1f, 17.15f)
                quadToRelative(-3.1f, 8.2f, -9.81f, 14.92f)
                lineTo(407.83f, 695.83f)
                quadTo(395.15f, 708.5f, 376.0f, 708.5f)
                reflectiveQuadToRelative(-31.83f, -12.67f)
                quadTo(331.5f, 683.15f, 331.5f, 664.0f)
                reflectiveQuadToRelative(12.67f, -31.83f)
                lineTo(496.35f, 480.0f)
                close()
            }
        }
        .build()
        return _keyboardArrowRightW500Rounded!!
    }

private var _keyboardArrowRightW500Rounded: ImageVector? = null
